import { Injectable } from '@angular/core';
import { ServiceMap } from '../models/service-map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ServiceProviders } from '../models/service-providers';
import { NagadServiceMap } from '../models/nagad-service-map';

@Injectable({
  providedIn: 'root',
})
export class NagadConfigService {
  public selectedItem!: ServiceMap;

  baseUrl = environment.nagadApiUrl;

  constructor(private httpClient: HttpClient) {}

  public get() {
    return this.httpClient.get<ServiceMap[]>(this.baseUrl + `/api/config/get`);
  }

  public getMerchants() {
    return this.httpClient.get<ServiceMap[]>(this.baseUrl + `/api/config`);
  }

  public getByMarchent(marchant: string) {
    return this.httpClient.get<ServiceMap[]>(
      this.baseUrl + `/api/config/get_by_marchantet?marchant=${marchant}`
    );
  }

  public getDetailsByMarchent(marchant: string) {
    return this.httpClient.get<NagadServiceMap[]>(
      this.baseUrl + `/api/config/get_by_marchantet?marchant=${marchant}`
    );
  }
  public getServiceProviders() {
    return this.httpClient.get<ServiceProviders[]>(
      this.baseUrl + `/api/config/get_service_providers`
    );
  }
  public addService(val: string) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(
      this.baseUrl + `/api/config/add_product`,
      val,
      { headers }
    );
  }
}
